import { FINANCE_CONSTANTS } from "@constants/carFinance";

export const calculateEmi = (onRoadPrice: number): number => {
  if (onRoadPrice <= 0) return 0;
  const loanAmount = onRoadPrice * (1 - FINANCE_CONSTANTS.DEFAULT_DOWN_PAYMENT_PERCENTAGE);
  const monthlyRate = FINANCE_CONSTANTS.MIN_INTEREST_RATE / (FINANCE_CONSTANTS.MONTHS * 100);
  const tenure = FINANCE_CONSTANTS.INITIAL_DURATION * FINANCE_CONSTANTS.MONTHS;
  const powerValue = Math.pow(1 + monthlyRate, tenure);
  return Math.round((loanAmount * monthlyRate * powerValue) / (powerValue - 1));
};